export default __webpack_public_path__ + "static/h10-c498b2cc79150a34dd2b67ea6bd53837.png";